import { Metamodel } from 'app/model/base/model';
import { BlobTypeStoreReadSettings } from './blob-type-store-read-settings';
import { IAttribute } from 'app/model/base/annotation';

import { AmazonS3LinkedService } from 'app/model/linkedservice/amazon-s3.linkedservice';
import { FilePathMode } from 'app/registries/consts/metadata-consts';
import { StoreReadSettings } from './store-read-settings';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.amazonS3.storeRead,
    display: [],
    tags: {
        linkedServiceModel: Metamodel.modelFor(AmazonS3LinkedService)
    }
})

export class S3StoreReadSettings extends BlobTypeStoreReadSettings {
    public static readonly PREFIX: IAttribute;
    public supportedFilePathMode = [
        FilePathMode.DATASET,
        FilePathMode.PREFIX,
        FilePathMode.WILDCARD,
        FilePathMode.LIST
    ];

    @Metamodel.attribute({
        templatable: true,
        association: 'PREFIX',
        display: stringResources.Prefix
    })
    public prefix?: string;

    public recoverPropFromPrevOne(prevStoreSettings: StoreReadSettings): void {
        super.recoverPropFromPrevOne(prevStoreSettings);
        this.updateModelValue('prefix', this, prevStoreSettings);
    }
}
